import { useRouter } from "next/router";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import {
  BACKEND_API_ROUTE,
  POOJA_WISHLIST_API,
  POOJA_CART_API,
} from "@/commons/api_routes";
import toast from "react-hot-toast";
import { POSTREQUESTAPI } from "@/pages/api/apiUtils";
import PoojaImageComponent from "../PoojaComponent/PoojaImageBoxComponent";
import { getCookieItem } from "@/utils/utils";

const PoojasComponent = ({ data }) => {
  const router = useRouter();
  const language = getCookieItem('language_name')?.toLowerCase();
  const location = getCookieItem('location_name')?.toLowerCase();
  

  const postUserCartApi = async (data) => {
    try {
      const cartApiUrl = BACKEND_API_ROUTE + POOJA_CART_API;
      const language = getCookieItem("language");
      // Location Default Setting
      // const location = getCookieItem("location");
      const location = getCookieItem("location");
      const accessToken = getCookieItem("accessToken");
      const payload = {
        poojaId: data._id,
        language,
        location,
      };
      const cartResponse = await POSTREQUESTAPI(
        cartApiUrl,
        payload,
        accessToken
      );
      if (cartResponse.status === 201) {
        if (cartResponse.data.statusCode === 200) {
          toast.success(cartResponse.data.message);
        } else {
          toast.error(cartResponse.data.error);
        }
      } else {
        toast.error(cartResponse.data.error);
      }
    } catch (error) {
      toast.error("Error fetching cart API");
    }
  };

  const postUserWishlistApi = async (data) => {
    try {
      const wishlistApiUrl = BACKEND_API_ROUTE + POOJA_WISHLIST_API;
      const accessToken = getCookieItem("accessToken");
      const payload = {
        poojaId: data._id,
      };
      const wishlistResponse = await POSTREQUESTAPI(
        wishlistApiUrl,
        payload,
        accessToken
      );
      if (wishlistResponse.status === 201) {
        if (wishlistResponse.data.statusCode === 200) {
          toast.success(wishlistResponse.data.message);
        } else {
          toast.error(wishlistResponse.data.error);
        }
      } else {
        toast.error(wishlistResponse.data.error);
      }
    } catch (error) {
      if (error.response.status === 401) {
        toast("Please login to add item to wishlist");
      } else {
        toast.error("Error fetching wishlist API");
      }
    }
  };

  const onClickViewAll = () => {
    const locationName = getCookieItem("location_name")?.toLowerCase();
    const languageName = getCookieItem("language_name")?.toLowerCase();
    const poojaPath = `/${languageName}/${locationName}/pooja/`;
    router.push(poojaPath);
  };

  const handlePoojaImageClick = (poojaBox) => {
    const locationName = getCookieItem("location_name")?.toLowerCase();
    const languageName = getCookieItem("language_name")?.toLowerCase();
    const poojaPath = `/${languageName}/${locationName}/pooja/${poojaBox.slug}`;
    router.push(poojaPath);
  };

  const imageBoxesData = data.boxesData;
  const boxHeight = data.boxHeight;
  const boxWidth = data.boxWidth;

  return (
    <div className="flex flex-col justify-center text-Default bg-white pb-4 pt-4 md:pt-8 lg:pt-12 md:pb-16 px-6 xs:px-8 sm:px-12 md:px-16 lg:px-20 xl:px-35 relative">
      <div className="flex flex-row justify-between items-start ">
        <h3 className="flex flex-row justify-start items-center gap-4 text-md md:text-lg lg:text-2xl xl:text-3xl 2xl:text-4xl font-bastoni tracking-wide">
          {data.title}
          <div className="flex align-top lg:my-1 items-center relative w-5 h-5 md:w-7 md:h-7 lg:w-8 lg:h-8 xl:w-10 xl:h-10">
            <ImageWrapper
              src={data.titleImage}
              alt="Title Image"
              className="w-full h-full object-fit rounded-2xl"
            />
          </div>
        </h3>
        <button
          type="button"
          className="flex md:hidden text-sm cursor-pointer"
          onClick={onClickViewAll}
        >
          more
        </button>
        <button
          type="button"
          className="hidden md:flex text-sm cursor-pointer"
          onClick={onClickViewAll}
        >
          View all
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:flex items-start justify-center md:justify-start pt-4 md:pt-10 gap-3 xs:gap-4 md:overflow-x-auto md:scrollbar-hide my-4">
        {imageBoxesData &&
          imageBoxesData.map((boxData, index) => (
            <PoojaImageComponent
              key={`pooja-${index}`}
              imageUrl={boxData.media[0].mediaUrl}
              altText={boxData.name}
              boxHeight={boxHeight}
              boxWidth={boxWidth}
              containerClass="w-1/2 md:w-1/4"
              poojaData={boxData}
              handlePoojaItemClick={handlePoojaImageClick}
              postUserWishlistApi={postUserWishlistApi}
              postUserCartApi={postUserCartApi}
              location={location}
              language= {language}
            />
          ))}
      </div>
    </div>
  );
};

export default PoojasComponent;
